import { render } from "./PostProfile.vue?vue&type=template&id=dfcc39a6&scoped=true&ts=true"
import script from "./PostProfile.vue?vue&type=script&lang=ts"
export * from "./PostProfile.vue?vue&type=script&lang=ts"

import "./PostProfile.vue?vue&type=style&index=0&id=dfcc39a6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfcc39a6"]])

export default __exports__